// extracted by mini-css-extract-plugin
export default {"wrapper":"SavedPaymentMethodSelectCard_wrapper__8itBO","content":"SavedPaymentMethodSelectCard_content__DEnGv","actions":"SavedPaymentMethodSelectCard_actions__wY20L"};